// Kept apart from the recorder, so checking costs the page nothing: the recorder loads when it's used.

/** Whether this browser can record from the microphone (spec §19.3); it needs a secure page, too. */
export const canRecord = (): boolean =>
  typeof MediaRecorder !== 'undefined' && !!navigator.mediaDevices?.getUserMedia && window.isSecureContext;
